import { render, staticRenderFns } from "./VOrderComment.vue?vue&type=template&id=2ae98ae8&scoped=true"
import script from "./VOrderComment.vue?vue&type=script&lang=ts"
export * from "./VOrderComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae98ae8",
  null
  
)

export default component.exports